import { render, staticRenderFns } from "./OrgContrast.vue?vue&type=template&id=23853212&scoped=true"
import script from "./OrgContrast.vue?vue&type=script&lang=js"
export * from "./OrgContrast.vue?vue&type=script&lang=js"
import style0 from "./OrgContrast.vue?vue&type=style&index=0&id=23853212&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23853212",
  null
  
)

export default component.exports